import { io } from "socket.io-client";
import * as api from './api';
import * as utils from './utils';
import * as EventEmitter from 'events';

class RemoteClientProcessor extends EventEmitter {
    constructor() {
        super();

        window._client = this;

        const socket = this.socket = io(api.CURRENT_ENV.admin, {
            // transports: ["websocket", "polling"] // use WebSocket first, if available
            transports: ["websocket"], // use WebSocket first, if available
            pingInterval: 60000,
            pingTimeout: 60000,
            upgradeTimeout: 30000
        });

        socket.on("response", (e) => {
            this.handleResponse(e.event, e.params);
        });

        socket.on("connect", () => {
            console.log(`RemoteClient:connected`);
        });

        socket.on("disconnect", (e) => {
            console.log(`RemoteClient:disconnect`, e);
        });

        socket.on("close", (e) => {
            console.log(`RemoteClient:close`, e);
        });

        socket.on("connect_error", (e) => {
            console.log(`RemoteClient:connect_error`, e);
            // revert to classic upgrade
            // socket.io.opts.transports = ["polling", "websocket"];
        });
        
        setInterval(() => {
            socket.emit("ping", { beat: 1 });
            this.heartbeat();
        }, 8000);

        // internal sending notification
        let _lastState = {
            isStreaming: false,
            isAllConnected: false
        };

        setInterval(() => {
            let app = this._app;
            if (!app) return;
            let roomInfo = this.roomInfo;

            // if (_lastState.isStreaming !== app.isStreaming) {
            //     if (app.isStreaming) {
            //         api.sendTelegram(roomInfo.name, roomInfo.id, roomInfo.video_room_id, 'Stream started', false);
            //     } else if (!app.isStreaming) {
            //         api.sendTelegram(roomInfo.name, roomInfo.id, roomInfo.video_room_id, 'Streaming stopped', false);
            //     }
            // }

            if (_lastState.isAllConnected !== app.isAllConnected) {
                if (_lastState.isAllConnected && !app.isAllConnected) {
                    api.sendTelegram(roomInfo.name, roomInfo.id, roomInfo.video_room_id, 'Lost connection', false);
                    app.reloadSettings();
                } else if (!_lastState.isAllConnected && app.isAllConnected) {
                    api.sendTelegram(roomInfo.name, roomInfo.id, roomInfo.video_room_id, 'Connection established/restored', false);
                }
            }

            _lastState.isStreaming = app.isStreaming;
            _lastState.isAllConnected = app.isAllConnected;
        }, 2000);

        setTimeout(() => {
            let app = this._app;
            if (!app) return;
            let roomInfo = this.roomInfo;
            api.sendTelegram(roomInfo.name, roomInfo.id, roomInfo.video_room_id, 'Re/loaded', true);
        }, 1000);
    }

    get sid() {
        return this.socket.id;
    }

    get roomId() {
        return api.getSavedTableId();
    }

    get videoId() {
        return this.roomInfo?.video_room_id;
    }

    get roomInfo() {
        if (!this._app) return null;
        return this._app.roomInfo;
    }

    get isStreaming() {
        return !!this._app && !!this._app.isStreaming;
    }

    setApp(app) {
        this._app = app;
    }

    sent(event, params) {
        if (!this.socket?.connected) return;
        this.socket.emit('request', {
            sid: this.sid,
            roomId: this.roomId || '',
            videoId: this.videoId || '',
            event: event,
            params
        });
    }

    updatePreview() {
        let outputs = null;
        if (this._app) {
            outputs = this._app.getCameraOutputs();
        }
        this.sent('videos', outputs);
    }

    heartbeat() {
        this.sent('heartbeat', {
            "id": api.getSavedTableId(),
            "isStreaming": this.isStreaming,
            "scene": !!this._app ? 'main' : 'settings'
        });
        this.updatePreview();
    }

    handleResponse(event, params) {
        console.log(`handleResponse`, event);
        switch (event) {
            case 'refresh':
                window.location.href = window.location.origin;
                break;
            case 'life_ask':
                this.heartbeat();
                break;
            case 'streaming_reload':
                this.handleReload();
                break;
            case 'streaming_start':
                this.handleStart();
                break;
            case 'streaming_stop':
                this.handleStop();
                break;
            case 'ask_inputs':
                this.handleAskInputs();
                break;
            case 'save_inputs':
                this.handleSaveInputs(params);
                break;
            default:
                break;
        }
    }

    handleStart() {
        if (!!this._app) {
            this.sent('streaming_start_result', {
                result: true,
                message: 'OK'
            })
            this._app.startStreaming();
        } else {
            this.sent('streaming_start_result', {
                result: false,
                message: 'in settings'
            })
        }
    }

    handleStop() {
        console.log(`handleStop`);
        if (!!this._app) {
            this.sent('streaming_stop_result', {
                result: true,
                message: 'OK'
            })
            this._app.stopStreaming();
        } else {
            this.sent('streaming_stop_result', {
                result: false,
                message: 'in settings'
            })
        }
    }

    handleReload() {
        if (!!this._app) {
            this.sent('streaming_reload_result', {
                result: true,
                message: 'OK'
            })
            this._app.reloadSettings();
        } else {
            this.sent('streaming_reload_result', {
                result: false,
                message: 'in settings'
            })
        }
    }

    handleAskInputs() {
        utils.getVideoInputs().then((inputs) => {
            this.sent('inputs', { inputs_video: inputs });
        });
    }

    handleSaveInputs(params) {
        api.setApplicationInputs(params.cameraTop, params.cameraBillBoard);
        this.sent('input_saved');
    }
}

export const RemoteClient = new RemoteClientProcessor();
// module.exports = Client;
export default RemoteClientProcessor;